:host {
  --aha-event-list-group-heading--highlight-background-color: var(--theme-blue-background);
  --aha-event-list-group-heading--highlight-text-color: var(--theme-blue-text);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacer-1);
  font-size: 1rem;
  background-color: var(--theme-secondary-background);
  color: var(--theme-secondary-text);
  padding: var(--spacer-2) var(--spacer-3);
  margin-bottom: var(--spacer-05);
}

:host .event-list-date {
  display: flex;
  align-items: center;
  gap: var(--spacer-1);
}

:host .date,
:host .day {
  font-weight: 600;
  color: var(--theme-primary-text);
}

:host([highlight]) .day {
  color: var(--aha-event-list-group-heading--highlight-text-color);
  background: var(--aha-event-list-group-heading--highlight-background-color);
  text-align: center;
  display: flex;
  padding: var(--spacer-05) var(--spacer-1);
  margin: calc(0px - var(--spacer-1)) 0 calc(0px - var(--spacer-1)) 0;
  justify-content: center;
  align-items: center;
  gap: var(--spacer-1, 4px);
  border-radius: var(--Common--border-radius);
}
